import { NavLink, Outlet } from 'react-router-dom';
import { useSession } from '../auth/SessionProvider';
import { useI18n } from '../i18n';
import { Button } from './ui';

export function Layout() {
  const { me, logout, isStaff } = useSession();
  const { t, locale, setLocale } = useI18n();

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">
          <span className="brand-name">{t('app.title')}</span>
          <span className="brand-sub">{t('app.subtitle')}</span>
        </div>

        <nav className="nav">
          <NavLink to="/serveur">{t('nav.servers')}</NavLink>
          <NavLink to="/licences">{t('nav.licenses')}</NavLink>
          {isStaff ? <NavLink to="/admin">{t('nav.admin')}</NavLink> : null}
        </nav>

        <div className="topbar-right">
          <Button onClick={() => setLocale(locale === 'fr' ? 'en' : 'fr')}>
            {t('nav.language')}
          </Button>
          {me ? (
            <>
              <span className="who">{me.globalName ?? me.username}</span>
              <Button onClick={() => void logout()}>{t('nav.logout')}</Button>
            </>
          ) : null}
        </div>
      </header>

      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
